import { Navigate } from 'react-router-dom';
import useSettings from '../hooks/useSettings';

// Sends the user home when a page is hidden by the vendor's Simple view.
export default function SimpleViewGuard({ children }) {
  const { simpleView } = useSettings();
  return simpleView ? <Navigate to="/" replace /> : children;
}
